export const NAME = 'PrevodNd';
